import { TextBoxProps } from 'src/types';
import i18next from '../../../i18n';
import TextField from '../../atomsLegacy/TextField';
import { PasswordTextBox } from '../../moleculesLegacy/PasswordTextBox';
import { WhiteTextBox } from '../../moleculesLegacy/WhiteTextBox/WhiteTextBox';

function Textbox(props: TextBoxProps) {
  if (props.password) {
    const direction = i18next.dir ? i18next.dir() : 'ltr';
    return <PasswordTextBox {...props} direction={direction} />;
  } else if (props.isWhite) {
    return <WhiteTextBox {...props} />;
  } else {
    return (
      <TextField
        disabled={props.disabled || false}
        data-testid={props['data-testid']}
        label={props.placeholder}
        id={props.id}
        onChange={props.onChange}
        value={props.value}
        error={!props.valid}
        onKeyPress={(e) => {
          if (props.enterKeyAction && e.charCode === 13) {
            e.preventDefault();
            props.enterKeyAction();
          }
        }}
      />
    );
  }
}

export const TextBox = Textbox;
